import PropTypes from 'prop-types';
import _ from 'lodash';

import { FORM_STATUS } from './globals';

const shapes = {
  form: {
    id: PropTypes.string.isRequired,
    status: PropTypes.oneOf(_.values(FORM_STATUS)).isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    link: PropTypes.string.isRequired,
    privacy: PropTypes.string
  },
  formWithSchema: {
    id: PropTypes.string.isRequired,
    status: PropTypes.oneOf(_.values(FORM_STATUS)).isRequired,
    description: PropTypes.string,
    JSONSchema: PropTypes.object.isRequired,
    UISchema: PropTypes.object,
    formData: PropTypes.object
  },
  JSONSchema: {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    properties: PropTypes.object.isRequired
  },
  UISchema: {
    'ui:order': PropTypes.arrayOf(PropTypes.string)
  }
};

export default shapes;
